<mat-dialog-content class="tw:h-full">
  <div class="tw:w-full tw:p-0 tw:m-0 content-container tw:h-full">

    <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:h-full">

      <div class="tw:flex-1 tw:m-0 tw:p-0 modal-type-container">
        <div class="tw:h-full tw:w-full"
        [ngClass]="{'error-modal': !data.isValidationError, 'validation-error-modal': data.isValidationError, 'info-error-modal': data.isAuthFailedInfoError}"></div>
        <div class="icon-container">
          <!-- <div [ngClass]="{'error-modal-icon': !data.isValidationError, 'validation-modal-icon': data.isValidationError, 'info-modal-icon': data.isAuthFailedInfoError}"></div> -->

          @if (!data.isValidationError && !data.isAuthFailedInfoError) {
            <i class="las la-exclamation-circle la-5x white-icon"></i>
          }
          @if (data.isAuthFailedInfoError) {
            <i class="las la-info-circle la-5x "></i>
          }
          @if (data.isValidationError) {
            <i class="las la-exclamation-triangle la-5x white-icon"></i>
          }
        </div>
      </div>

      <div class="tw:flex-1 modal-message-container">
        <p style="font-size: 24px;">{{ data.title != '' ? data.title : data.isValidationError ? 'Whoops...' : 'An error has occurred' }}</p>

        @if (!data.isAuthFailedInfoError) {
          <p class="font-16">{{data.errorMessage}}</p>
        }
        @if (data.isAuthFailedInfoError) {
          <p class="font-16">Logging you out due to a failure to authenticate, please log back in.</p>
        }

        @if (data.support) {
          <p class="font-16 support-details-intro">If the problem persists, please share these details with support:</p>
          <dl class="support-details">
            <dt>Time</dt><dd>{{ data.support.timestamp }}</dd>
            <dt>Request</dt><dd class="support-mono">{{ data.support.method }} {{ data.support.url }}</dd>
            <dt>Status</dt><dd>{{ data.support.status }} {{ data.support.statusText }}</dd>
            <dt>User</dt><dd>{{ data.support.user }}</dd>
            <dt>Request ID</dt><dd class="support-mono">{{ data.support.requestId ?? 'n/a' }}</dd>
            @if (data.support.correlationId) {
              <dt>Correlation ID</dt><dd class="support-mono">{{ data.support.correlationId }}</dd>
            }
          </dl>
        }

        <div class="modal-button-container">
          @if (data.support) {
            <button mat-button (click)="copyDetails()"
              class="btn tw:my-1 tw:mx-1 btn-outline-primary"
            tabindex="-1">{{ copied ? 'Copied!' : 'Copy for support' }}</button>
          }
          <button mat-button [mat-dialog-close]="false"
            class="btn tw:my-1 tw:mx-1 btn-primary"
          tabindex="-1">Dismiss</button>
          <!-- [ngClass]="{'btn-outline-error': !data.isValidationError, 'btn-outline-validation': data.isValidationError, 'btn-outline-info-error': data.isAuthFailedInfoError}" -->
        </div>

      </div>

    </div>

  </div>

</mat-dialog-content>